export const fieldsTranslationsRu = {
  'fields-parameters.navbar.services.title': 'Сервисы',
  'fields-parameters.title': 'Параметры полей',
  'fields-parameters.services.table.title': 'Поля',
  'service.field_parameters.column.farmer_name.label': 'Хозяйство',
  'service.field_parameters.column.field_number.label': 'Количество полей',
  'service.field_parameters.column.total_area.label': 'Общая площадь (га)',
  'service.field_parameters.detail_panel.column.field_name.label': 'Название поля',
  'service.field_parameters.detail_panel.column.area.label': 'Площадь (га)',
  'service.field_parameters.detail_panel.column.service.label': 'Сервис',
  'service.field_parameters.detail_panel.column.crop.label': 'Культура',
  'service.field_parameters.detail_panel.column.subscription.label': 'Подписка',
  'service.field_parameters.detail_panel.column.subscription.active.label': 'Активна',
  'service.field_parameters.detail_panel.column.subscription.no_subscription.label': 'Нет подписки',
  'service.field_parameters.detail_panel.column.service.button.parameter.label': 'Параметры',
  'irrigation_field_service_parameters.button.undo.label': 'Отменить изменения',
  'irrigation_field_service_parameters.button.save.label': 'Сохранить изменения',
  'irrigation_field_service_parameters.multiple_edition.button.apply.label': 'Применить',
  'irrigation_field_service_parameters.multiple_edition.button.clear.label': 'Очистить',
  'irrigation_field_service_parameters.multiple_edition.title.label': 'Редактирование нескольких полей',
  'irrigation_field_service_parameters.multiple_edition.info.setp1':
    '1- Заполните поля, которые хотите применить к нескольким участкам',
  'irrigation_field_service_parameters.multiple_edition.info.setp2':
    '2- Выберите поля, к которым хотите применить параметры',
  'irrigation_field_service_parameters.multiple_edition.info.setp3':
    '3- Подтвердите, нажав кнопку «Применить» (Внимание: могут появиться ошибки)',
  'irrigation_field_service_parameters.multiple_edition.info.setp4': '4- Сохраните для применения обновления',
  'irrigation_field_service_parameters.table.Column.farmer_name.label': 'Хозяйство',
  'irrigation_field_service_parameters.table.Column.field_number.label': 'Количество полей',
  'irrigation_field_service_parameters.table.Column.total_area.label': 'Общая площадь (га)',
  'irrigation_field_service_parameters.table.detail_panel.column.field.label': 'Поле',
  'irrigation_field_service_parameters.table.detail_panel.column.soil.label': 'Почва',
  'irrigation_field_service_parameters.table.detail_panel.column.weather_station.label': 'Метеостанция',
  'irrigation_field_service_parameters.table.detail_panel.column.irrigation_management.label': 'Управление орошением',
  'irrigation_field_service_parameters.table.detail_panel.column.irrigation_threshold.label': 'Порог орошения',
  'irrigation_field_service_parameters.table.detail_panel.column.assolment.label': 'Севооборот',
  'fields-parameters.dialog.error.title': 'Ошибка при сохранении',
  'fields-parameters.dialog.error.legend': 'Некоторые из ваших изменений столкнулись с ошибками и не были сохранены.',
  'fields-parameters.dialog.error.contact':
    'Если проблема persists, пожалуйста, передайте эти ошибки нашему сервису поддержки на адрес csm@pixagri.fr',
};
